export enum UnrealisedFXGainOrLossType {
  FXGainOrLoss = 'FXGainOrLoss',
  FXUnwind = 'FXUnwind',
}

export enum UnrealisedFXGainOrLossSubType {
  FXGainPayable = 'FXGainPayable',
  FXLossPayable = 'FXLossPayable',
  FXGainReceivable = 'FXGainReceivable',
  FXLossReceivable = 'FXLossReceivable',
}

export const UnrealisedFXGainOrLossActionTypeLabels = {
  [UnrealisedFXGainOrLossType.FXGainOrLoss]: 'Unrealised FX Gain/Loss',
};
